import {h} from "preact";
import {GlobalsContext} from "../AppContext";
import {useContext} from "preact/hooks";
import style from './close-button.css';
import clsx from "clsx";

interface OwnProps {
    icon?: string;
    title?: string;
}

const CloseButton = ({ title, icon}: OwnProps) => {
    const { widgetOpen,setWidgetOpen } = useContext(GlobalsContext);

    return (
        <div className={clsx(style.root,widgetOpen ? style.open : style.minimized)} onClick={() => setWidgetOpen(false)} />
    );
};

export default CloseButton;
